<template>
    <div class="header">
    <nav class="main-header navbar navbar-expand bg-navy navbar-light border-bottom">
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="javascript:void(0)">
                    <fa :icon="fas.faBars" />
                </a>
            </li>
            <li class="nav-item d-none d-sm-inline-block">                    
                <a href="/" class="nav-link" style="font-family: 'Khmer MEF2'; color: black;">{{ $t('label.temporary_vehicle')}}</a>
            </li>
        </ul>
        <ul class="navbar-nav ml-auto">
            <!-- <li class="nav-item">
                <a class="nav-link" :href="dashboardLink">
                    <fa :icon="fas.faTh" />
                    <span class="d-none d-md-inline-flex ml-1">
                        {{$t('label.dashboard')}}
                    </span>
                </a>
            </li> -->
            <dropdown-locale-changer />
            <service-switcher currentAppCode="tempvehicle" />
            <!-- <li class="nav-item dropdown">
                <a class="nav-link" data-toggle="dropdown" href="#">
                    <fa :icon="far.faBell" />
                    <span class="badge badge-warning navbar-badge">5</span>
                </a>
                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                    <span class="dropdown-item dropdown-header">15 Notifications</span>
                    <div class="dropdown-divider"></div>
                    <a href="#" class="dropdown-item">
                        <i class="fa fa-envelope mr-2"></i> 4 new messages
                        <span class="float-right text-muted text-sm">3 mins</span>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a href="#" class="dropdown-item">
                        <i class="fa fa-users mr-2"></i> 8 friend requests
                        <span class="float-right text-muted text-sm">12 hours</span>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a href="#" class="dropdown-item">
                        <i class="fa fa-file mr-2"></i> 3 new reports
                        <span class="float-right text-muted text-sm">2 days</span>
                    </a>
                    <div class="dropdown-divider"></div>
                    <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
                </div>
            </li> -->
            <li class="nav-item">
                <a class="nav-link" data-widget="control-sidebar" data-slide="true" @click="authLogout" title="Logout" href="javascript:void(0)">
                    <fa :icon="fas.faSignOutAlt" />
                </a>
            </li>
        </ul>
    </nav>
    </div>
</template>

<script>
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { mapActions } from "vuex";
export default {
    name: "Header",
    computed: {
        far() {
            return far;
        },
        fas() {
            return fas;
        },
        // dashboardLink() {
        //     // const redirectUrl = process.env.VUE_APP_USER_DASHBOARD_URL;
		//   	// const port = window.location.port ? ':' + window.location.port : '';
		//   	// const ref = window.location.protocol + '//' + window.location.hostname + port
        //     // return redirectUrl + '/logout?ref=' + encodeURIComponent(ref);
        //     const url = process.env.VUE_APP_USER_DASHBOARD_URL;
        //     const appPrefix = process.env.VUE_APP_PREFIX;
        //     const cipherToken = localStorage.getItem(appPrefix + "token");
        //     return url + `?token=${encodeURIComponent(cipherToken)}`;       
        // }
    },
    methods: {
        ...mapActions("auth", ["logout"]),
        authLogout() {
            this.logout();
        }
    }
};
</script>

<style scoped>
    .moduleIcon {
        color: blue;
        
    }
</style>
